export function emojiToCursor(emoji: string, size: number): string {
  const canvas = document.createElement("canvas");
  const s = Math.max(size, 24);
  canvas.width = s;
  canvas.height = s;
  const ctx = canvas.getContext("2d");
  if (!ctx) return "crosshair";
  ctx.font = `${s}px serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(emoji, s / 2, s / 2);
  return `url(${canvas.toDataURL()}) ${s / 2} ${s / 2}, crosshair`;
}
